import ProjectCard from "./ProjectCard";
import { projects, ProjectProps } from "./projectDetails";
import React, { useState } from "react";
import Link from "next/link";

interface ProjectGridProps {
  showLoadMore?: boolean;
}

const ProjectGrid = ({ showLoadMore = false }: ProjectGridProps) => {
  const [displayCount, setDisplayCount] = useState(4);
  const PROJECTS_PER_PAGE = 4;

  const visibleProjects = showLoadMore
    ? projects.slice(0, displayCount)
    : projects;
  const hasMore = showLoadMore && displayCount < projects.length;

  return (
    <>
      <div className="mb-10 flex gap-16 text-[#e4ded7] md:mb-16  lg:mb-20 ">
        <h4
          className={`text-[16px] md:text-[20px] lg:text-[34px] ${"text-[#e4ded7]"}`}
        >
          Check out some of my work!
        </h4>
      </div>

      <div className="grid w-[90%] grid-cols-1 grid-rows-2 gap-y-10 gap-x-6 lg:max-w-[1200px] lg:grid-cols-1">
        {visibleProjects.map((project: ProjectProps) => (
          <ProjectCard
            id={project.id}
            key={project.id}
            name={project.name}
            description={project.description}
            technologies={project.technologies}
            techNames={project.techNames}
            techLinks={project.techLinks}
            github={project.github}
            demo={project.demo}
            image={project.image}
            available={project.available}
          />
        ))}
      </div>

      {showLoadMore && (
        <div className="mt-16 flex justify-center">
          {hasMore ? (
            <button
              onClick={() =>
                setDisplayCount((prev) => prev + PROJECTS_PER_PAGE)
              }
              className="rounded-lg bg-white px-8 py-3 text-[16px] font-semibold text-[#0E1016] transition-all duration-300 hover:bg-[#e4ded7] md:text-[18px]"
              data-blobity
              data-blobity-magnetic="false"
            >
              Load More
            </button>
          ) : (
            <Link
              href="/work"
              className="rounded-lg bg-white px-8 py-3 text-[16px] font-semibold text-[#0E1016] transition-all duration-300 hover:bg-[#e4ded7] md:text-[18px]"
              data-blobity
              data-blobity-magnetic="false"
            >
              View More Projects ?
            </Link>
          )}
        </div>
      )}
    </>
  );
};

export default ProjectGrid;
